import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './PDFViewer.css';

const PDFViewer = ({ 
  pdfPath, 
  title = "Guide", 
  allowDownload = false,
  viewButtonText,
  hideButtonText
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useLanguage();

  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Construct the PDF URL
  const pdfUrl = process.env.PUBLIC_URL 
    ? `${process.env.PUBLIC_URL}${pdfPath}` 
    : pdfPath;

  const openPDFInNewTab = () => {
    window.open(pdfUrl, '_blank');
  };

  const downloadPDF = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfPath.split('/').pop() || 'document.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const displayViewText = viewButtonText || t('viewGuide');
  const displayHideText = hideButtonText || t('hideGuide');

  return (
    <section className="pdf-viewer-section">
      <div className="pdf-viewer-container">
        <div className="pdf-viewer-header">
          <h2 className="pdf-viewer-title">{title}</h2>
          <button
            className="btn btn-primary pdf-toggle-btn"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? displayHideText : displayViewText}
          </button>
        </div>

        {isOpen && (
          <div className="pdf-viewer-wrapper">
            <div className="pdf-viewer-controls">
              <span className="pdf-note">
                {isMobile ? t('mobileScroll') : (allowDownload ? t('readOnly') + ' - ' + t('downloadPDF') : t('readOnly'))}
              </span>
              <div className="pdf-controls-buttons">
                {allowDownload && (
                  <button
                    className="btn btn-secondary pdf-download-btn"
                    onClick={downloadPDF}
                    style={{ marginLeft: '0.5rem', padding: '0.5rem 1rem', fontSize: '0.875rem' }}
                  >
                    {t('downloadPDF')}
                  </button>
                )}
                {isMobile && (
                  <button
                    className="btn btn-secondary pdf-open-btn"
                    onClick={openPDFInNewTab}
                    style={{ marginLeft: '0.5rem', padding: '0.5rem 1rem', fontSize: '0.875rem' }}
                  >
                    {t('openFullScreen')}
                  </button>
                )}
              </div>
            </div>
            <div 
              className="pdf-embed-container" 
              onContextMenu={allowDownload ? undefined : (e) => e.preventDefault()}
            >
              <iframe
                src={`${pdfUrl}#toolbar=${allowDownload ? '1' : '0'}&navpanes=0&scrollbar=1&zoom=page-fit`}
                title={title}
                className="pdf-iframe"
                type="application/pdf"
                onContextMenu={allowDownload ? undefined : (e) => e.preventDefault()}
                allowFullScreen
                scrolling="auto"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PDFViewer;

